// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"195":"login1","577":"login3","791":"login5"}[chunkId] + "." + {"195":"759105d5","577":"026cd33e","791":"6c396889"}[chunkId] + ".css";
};